import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import { createPetShop } from '../../actions/petShop'

const initialState={
    title: '',
    email: '',
    phone_number: '',
    first_name: '',
    last_name: '',
    country: '',
    domain: '',
    payments: [{method: 'cash', card_type: 'visa', amount: 0}],
    loading: false
};

class PetStore extends Component {

  constructor(props) {
    super(props);
  }

  state = initialState;

  submitPetstore = (event) => {
    this.setState({
        loading: true
    })

    const store = {
        title: this.state.title,
        email: this.state.email,
        phone_number: this.state.phone_number,
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        country: this.state.country,
        domain: this.state.domain
    }

    this.props.createPetstore(store);
  }

  changeVal = (event) => {
    this.setState({[event.target.name]: event.target.value})
  }

  changeCountry = (event) => {
    this.setState({country: event.value})
  }

  render() {
    const { title, email, phone_number, first_name, last_name, country, domain } = this.state;
    return (
        <div className="m-grid m-grid--hor m-grid--root m-page">
          <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2" id="m_login" style={{ backgroundImage: "url(../../../assets/app/media/img//bg/new-background.png)"}}>
              <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                <div className="m-grid__item m-grid__item--fluid m-wrapper mt-5">
                  <div className="col-md-6 mx-auto my-0">
                    <div className="m-portlet m-portlet--tab">
                      <div className="m-portlet__head">
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <span className="m-portlet__head-icon m--hide">
                            <i className="la la-gear"></i>
                            </span>
                            <h3 className="m-portlet__head-text">
                              Shop Registation Form	
                            </h3>
                          </div>
                        </div>
                      </div>
                      <form onSubmit={this.submitPetstore} className="m-form m-form--fit m-form--label-align-right">
                        <div className="m-portlet__body">
                            <div className="form-group m-form__group m--margin-top-10">
                            <div className="alert m-alert m-alert--default" role="alert">
                                Please fill this form
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">Title</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="text" value="Title" id="text-input"  onChange={this.changeVal} name="title" value={title}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="email-input" className="col-3 col-form-label">Email</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="email" value="Enter your email address" id="email-input"  onChange={this.changeVal} name="email" value={email}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">Phone Number</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="text" value="Enter your phone number" id="text-input"  onChange={this.changeVal} name="phone_number" value={phone_number}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">First Name</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="text" value="Enter your first name" id="text-input"  onChange={this.changeVal} name="first_name" value={first_name}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">Last Name</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="text" value="Enter your last name" id="text-input"  onChange={this.changeVal} name="last_name" value={last_name}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">Country</label>
                            <div className="col-9">
                                {/* <select className="form-control m-input" type="select" value="Select your country" id="text-select">
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select> */}

                                <Select  className="form-control m-input" options={[
                                    { value: 'united states', label: 'United States' },
                                    { value: 'united kindom', label: 'United Kindom' },
                                    { value: 'sri lanka', label: 'Sri Lanka' }

                                ]} value={country} onChange={this.changeCountry} placeholder="Select your country"/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label for="text-input" className="col-3 col-form-label">Select Domain</label>
                            <div className="col-9">
                                <input className="form-control m-input" type="text" value="Enter your domain" id="text-input"  onChange={this.changeVal} name="domain" value={domain}/>
                            </div>
                            </div>
                            <div className="form-group m-form__group row">
                            <label className="col-3 col-form-label">Upload Your File</label>
                            <div className="col-9">
                            <div className="m-dropzone dropzone dz-clickable" action="inc/api/dropzone/upload.php" id="m-dropzone-one">
                                <div className="m-dropzone__msg dz-message needsclick">
                                    <h3 className="m-dropzone__msg-title">Drop files here or click to upload.</h3>
                                    <span className="m-dropzone__msg-desc">This is just a demo dropzone. Selected files are <strong>not</strong> actually uploaded.</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="m-portlet__foot m-portlet__foot--fit">
                        <div className="m-form__actions">
                          <div className="row">
                            <div className="col-12">
                              <button type="reset" className="btn m-btn--pill btn-success pull-right" onClick={this.submitPetstore}>Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      );
  }
}

const mapStateToProps = state => ({
  data: state,
  user: state.cognito.user,
  userSub: state.cognito.userSub
});

const mapDispatchToProps = dispatch => ({
    createPetstore: (attrs) => {
        dispatch(createPetShop(attrs));
    }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PetStore));
